import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RandomContent from '../Components/RandomContent';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GetPageContentBySlug } from '../services/apiservice';
import { Helmet } from 'react-helmet-async';
import { loremIpsumGeneratorFAQ } from '../Seo/faqSchemas';

const LoremIpsumGenerator = () => {
  const location = useLocation();
  const paramlink = location.pathname.replace('/', '');

  const [pageContent, setPageContent] = useState(null);

  const [type, setType] = useState('paragraphs');
  const [count, setCount] = useState(3);
  const [output, setOutput] = useState('');

  const LOREM =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';

  useEffect(() => {
    GetPageContent();
  }, []);

  const GetPageContent = async () => {
    if (paramlink !== undefined && paramlink !== "") {
      try {
        const postMetaList = await GetPageContentBySlug(paramlink);
        const jsonMetaList = JSON.parse(postMetaList);
        setPageContent(jsonMetaList);
      } catch (error) {
        console.error('Error fetching the meta data:', error);
      }
    }
  };

  const generateLorem = () => {
    let result = '';
    const num = Math.max(1, parseInt(count) || 1);

    if (type === 'paragraphs') {
      for (let i = 0; i < num; i++) {
        result += LOREM + "\n\n";
      }
    } else if (type === 'sentences') {
      for (let i = 0; i < num; i++) {
        result += LOREM.split('. ').slice(0, 1) + ". ";
      }
    } else if (type === 'words') {
      const words = LOREM.split(' ');
      for (let i = 0; i < num; i++) {
        result += words[i % words.length] + ' ';
      }
    }
    setOutput(result.trim());
  };

  const handleClear = () => {
    setCount(3);
    setType('paragraphs');
    setOutput('');
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(output);
    toast.success('Copied to clipboard!', { position: "top-right", autoClose: 2000 });
  };

  return (
    <>
      <Helmet>
        <title>{pageContent?.section1header || "Free Lorem Ipsum Generator - Generate Placeholder Text - Data Beautifier"}</title>
        <meta name="description" content="Generate Lorem Ipsum placeholder text instantly. Perfect for web designers and developers creating mockups and prototypes. Free and customizable." />
        <link rel="canonical" href={`https://databeautifier.com/${paramlink}`} />
        <meta property="og:title" content={pageContent?.section1header} />
        <meta property="og:url" content={`https://databeautifier.com/${paramlink}`} />
        <script type="application/ld+json">
            {JSON.stringify(loremIpsumGeneratorFAQ)}
        </script>
      </Helmet>

      <Header />
      <RandomContent />

      {/* Info Section */}
      <div className="blog-area">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-12 col-md-12">
              <div
                className="single-blog-inner shadow-sm p-4 mb-4"
                data-aos="fade-up"
                data-aos-duration="2800"
              >
                <div className="details">
                  <h4><a href="#">{pageContent?.section1header}</a></h4>

                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        pageContent?.section1text ||
                        '<p>Generate placeholder text for your projects quickly. Choose the number of paragraphs, sentences, or words and copy them instantly. 🚀</p>',
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Generator Section */}
      <div className="blog-area pb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-6 col-md-8">
              <div className="single-blog-inner p-5 shadow-lg rounded-3" data-aos="fade-up" data-aos-duration="2800">

                {/* Controls */}
                <div className="mb-3 d-flex gap-2 flex-wrap">
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Type</label>
                    <select className="form-control" value={type} onChange={(e) => setType(e.target.value)}>
                      <option value="paragraphs">Paragraphs</option>
                      <option value="sentences">Sentences</option>
                      <option value="words">Words</option>
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label className="form-label">Count</label>
                    <input
                      type="number"
                      className="form-control"
                      min="1"
                      max="50"
                      value={count}
                      onChange={(e) => setCount(e.target.value)}
                    />
                  </div>
                </div>

                {/* Buttons */}
                <div className="d-flex gap-2 mb-3">
                  <button className="default-btn icon four" onClick={generateLorem}>Generate</button>
                  <button className="default-btn icon outline" onClick={handleClear}>Clear</button>
                  {output && <button className="default-btn icon outline" onClick={handleCopy}>Copy</button>}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Fullscreen Output Section */}
      {output && (
        <div className="lorem-output-area py-5 bg-light">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-10 col-md-12">
                <div className="single-blog-inner p-4 shadow-sm rounded-3" style={{ whiteSpace: 'pre-wrap', fontSize: '1rem', lineHeight: 1.6 }}>
                  {output}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Optional Bottom Content */}
      {pageContent?.section2text && (
        <div className="blog-area pt-20">
          <div className="container-block-fluid">
            <div className="row justify-content-center">
              <div className="full-col col-lg-12 col-md-12">
                <div
                  className="single-blog-inner p-4"
                  data-aos="fade-up"
                  data-aos-duration="2800"
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: pageContent.section2text,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Section 3 Below Boxes */}
      {pageContent?.section3text &&
        pageContent.section3text.trim() !== "" && (
          <div className="blog-area">
            <div className="container-block-fluid">
              <div className="row justify-content-center">
                <div className="full-col col-lg-12 col-md-12">
                  <div
                    className="single-blog-inner"
                    data-aos="fade-up"
                    data-aos-duration="2800"
                  >
                    <div className="details">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pageContent.section3text,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      <Footer />
      <ToastContainer />

      <style jsx>{`
        .form-label {
          font-weight: 600;
          margin-bottom: 5px;
        }
        .d-flex button {
          flex: 1;
        }
        @media(max-width: 576px) {
          .d-flex, .d-flex > div {
            flex-direction: column !important;
            margin-bottom: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default LoremIpsumGenerator;
